// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3QPIq","inputWrap":"Table_inputWrap__e76Wv","col":"Table_col__X3-Hh","bmiTooltip":"Table_bmiTooltip__aTinE"};